import { sentenceCase } from 'change-case/change-case'

export default ({ id }) => sentenceCase(id)
